import { InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { SupportTicket } from '../entities/SupportTicket'

// Owner-scoped — takes no client filter, scoped inside the Action to `args.user`.
@InputType()
export class GetMySupportTicketsArgs extends ActionArgs {}

export interface IGetMySupportTickets extends IAction<SupportTicket[], GetMySupportTicketsArgs> {}
